// extracted by css-extract-rspack-plugin
export default {"subject":"subject-Ze4JE1","includeLink":"includeLink-J6dtSy","unread":"unread-wakig4","messagePreview":"messagePreview-fP5L9r"};